/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect } from "react";
import { connect } from "react-redux";

import legalPageStyle from "assets/jss/views/legalPage/legalPageStyle";
const useStyles = makeStyles(legalPageStyle);

import { sEmailContact } from "assets/jss/views/ResStrings";
import { getDoc, ApricotAction } from "client/actions/modal";
import { progressCircles } from "components/Form/FormField";

interface Props {
  getDoc: ApricotAction;
  docPolicy: string;
  classes: any;
}

const PolicyBase: React.FC<Props> = ({ getDoc, docPolicy }: Props) => {
  const classes = useStyles();
  useEffect(() => {
    docPolicy === null && getDoc(2);
  }, []);

  const HtmlToReactParser = require("html-to-react").Parser;
  const parser = new HtmlToReactParser();

  return docPolicy ? (
    <div className={classes.content}>
      <div className={classes.title}>Privacy Policy</div>
      {parser.parse(docPolicy)}
      <p>
        {`If you have any other questions about this policy, please email ${sEmailContact}.`}
      </p>
      <p className={classes.ending}>&sect;</p>
    </div>
  ) : (
    progressCircles()
  );
};

function mapStateToProps(state: any) {
  return {
    docPolicy: state.state_modal.docPolicy,
  };
}

const base: any = PolicyBase;
const Policy = connect(mapStateToProps, { getDoc })(base);
export default Policy;
